import styled from 'styled-components';

export const CheckboxLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
`;

/* Modern CleverParking checkbox: rounded square, brand-green fill + white check
   when ticked. Replaces the old broken <checkbox> element. */
export const CheckboxInput = styled.input`
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  box-sizing: border-box;
  width: 18px;
  height: 18px;
  margin: 0;
  flex: none;
  border: 1.5px solid #5f6872;
  border-radius: 5px;
  background-color: #2b3138;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;
  &:hover {
    border-color: #47b972;
  }
  &:checked {
    background-color: #47b972;
    border-color: #47b972;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='%23fff' stroke-width='2.2' stroke-linecap='round' stroke-linejoin='round' d='M3.5 8.4l3 3 6-6.6'/></svg>");
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
